"use client";

import { useState } from "react";
import { NavigationTabs } from "@/components/common/navigationTabs";
import { TableContainer } from "@/components/common/TableContainer";
import MetaFields from "@/components/settings/MetaFields";
import LegalPages from "@/components/settings/LegalPages";
import TaxesTab from "@/components/configuration/TaxesTab";
import ChargesTab from "@/components/configuration/ChargesTab";
import DomainsTab from "@/components/configuration/DomainsTab";

const configurationTabs = [
  { label: "Meta Fields", value: "meta" },
  { label: "Legal Pages", value: "legal" },
  { label: "Taxes", value: "taxes" },
  { label: "Charges", value: "charges" },
  { label: "Domains", value: "domains" },
];

const ConfigurationPage = () => {
  const [activeTab, setActiveTab] = useState<string>("meta");

  const renderTabContent = () => {
    switch (activeTab) {
      case "meta":
        return <MetaFields />;
      case "legal":
        return <LegalPages />;
      case "taxes":
        return <TaxesTab />;
      case "charges":
        return <ChargesTab />;
      case "domains":
        return <DomainsTab />;
      default:
        return <MetaFields />;
    }
  };

  return (
    <div className="space-y-4">
      <TableContainer
        navigationTabs={
          <NavigationTabs
            tabs={configurationTabs.map((tab) => ({
              label: tab.label,
              onClick: () => setActiveTab(tab.value),
              isActive: activeTab === tab.value,
            }))}
            hasBackButton={false}
          />
        }
      >
        {renderTabContent()}
      </TableContainer>
    </div>
  );
};

export default ConfigurationPage;
